import React from 'react';
import { Button as MuiButton } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledButton = styled(MuiButton)(({ variant }) => ({
  padding: '10px 28px',
  borderRadius: '6px',
  textTransform: 'none',
  fontWeight: 500,
  fontSize: '0.95rem',
  fontFamily: 'Inter, sans-serif',
  position: 'relative',
  overflow: 'hidden',
  transition: 'all 0.3s ease',
  
  ...(variant === 'contained' && {
    background: 'linear-gradient(to right, #004B87, #1A365D)',
    color: '#FFFFFF',
    border: 'none',
    boxShadow: 'none',
    '&:hover': {
      background: 'linear-gradient(to right, #1A365D, #004B87)',
      transform: 'translateY(-1px)',
      color: '#FFFFFF',
      boxShadow: 'none',
    },
    '&:active': {
      transform: 'translateY(1px)',
      color: '#FFFFFF',
      boxShadow: 'none',
    },
  }),

  ...(variant === 'outlined' && {
    backgroundColor: '#FFFFFF',
    color: '#004B87',
    border: '1.5px solid #004B87',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#F8FAFC',
      borderColor: '#1A365D',
      color: '#1A365D',
      boxShadow: 'none',
    },
  }),

  ...(variant === 'text' && {
    backgroundColor: 'transparent',
    color: '#004B87',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'rgba(0, 75, 135, 0.04)',
      color: '#1A365D',
      boxShadow: 'none',
    },
  }),

  '&.small': {
    padding: '8px 20px',
    fontSize: '0.875rem',
  },

  '&.large': {
    padding: '12px 32px',
    fontSize: '1rem',
  },

  '& .MuiButton-startIcon': {
    marginRight: '8px',
  },

  '&:disabled': {
    backgroundColor: variant === 'contained' ? '#E0E0E0' : 'transparent',
    backgroundImage: 'none',
    color: '#9E9E9E',
    borderColor: '#E0E0E0',
    boxShadow: 'none',
  },
}));

const CustomButton = ({ children, variant = 'contained', size = 'medium', ...props }) => {
  return (
    <StyledButton
      variant={variant}
      className={size}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

export default CustomButton;
